import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    // Auto-submit the form when any field changes
    this.element.requestSubmit()
  }
}